/**
 * ReportsHarvestInspectionsPeopleRequest Selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

// Selectors
import { selectCurrentEntityId } from '../../../../../../services/currentEntityId/selectors';
import { selectCurrentSeasonId } from '../../../../../../services/currentSeasonId/selectors';
import {
    makeSelectQueryStringValue,
    makeSelectQueryStringNumberValue
} from '../../../../../../workspaces/react-router-selectors';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const makeSelectParameters = () =>
    createDeepEqualSelector(
        [
            selectCurrentSeasonId,
            selectCurrentEntityId,
            makeSelectQueryStringValue('pickTypeName'),
            makeSelectQueryStringValue('varieties'),
            makeSelectQueryStringNumberValue('entities'),
            makeSelectQueryStringNumberValue('selectedEvent')
        ],
        (
            currentSeasonIdState,
            currentEntityIdState,
            queryStringPickTypeNameState,
            queryStringVarietiesState,
            queryStringEntitiesState,
            queryStringSelectedEventState
        ) => ({
            filter: {
                require: {
                    $and: [
                        // Season
                        currentSeasonIdState && {
                            'event.entity.seasonId': currentSeasonIdState
                        },
                        // Entity
                        currentEntityIdState && {
                            $or: [
                                {
                                    'event.entity.path': {
                                        $like: `/${currentEntityIdState}/%`
                                    }
                                    // TODO Filter out archived entities from reporting
                                    // 'event.entity.archivedAt': { $exists: false }
                                },
                                {
                                    'event.entityId': currentEntityIdState
                                    // TODO Filter out archived entities from reporting
                                    // 'event.entity.archivedAt': { $exists: false }
                                }
                            ]
                        },
                        // Pick Type
                        queryStringPickTypeNameState && {
                            'event.harvestEvent.pickType.name': queryStringPickTypeNameState
                        },
                        // Variety
                        queryStringVarietiesState &&
                            queryStringVarietiesState.length && {
                                'event.entity.defaultVarietyId': {
                                    $or: queryStringVarietiesState
                                }
                            },
                        // Entity
                        queryStringEntitiesState && {
                            'event.entity.parentEntity.id': queryStringEntitiesState
                        },
                        // Event
                        queryStringSelectedEventState && {
                            eventId: queryStringSelectedEventState
                        }
                    ].filter(value => value)
                }
            }
        })
    );

export { makeSelectParameters };
